import type {RecruiterHubAction} from 'src/action-creators/recruiter-hub';
import type {RecruiterHubState} from 'src/types/recruiter-hub';

import {
  RECEIVE_RECRUITER_HUB_INFO,
  UPDATE_RECRUITER_HUB_INFO,
  RESET_RECRUITER_HUB_STATE,
} from 'src/action-creators/recruiter-hub';


const initialState: RecruiterHubState = {
  // identity
  id: '',
  job_id: '',
  candidate_id: '',

  // debug
  is_debug: '',

  // current stage
  current_stage: '',

  // common
  match_score: '',

  // applicant
  applicant_id: '',
  applicant_created_at: '',
  applicant_owner_type: '',
  applicant_owner_id: '',
  applicant_evaluation_score: '',
  job_submission_id: '',

  // screening
  screening_initiated_at: '',
  screening_owner_type: '',
  screening_owner_id: '',
  screening_source_type: '',
  screening_source_id: '',
  screening_summary: '',
  screening_transcript: '',
  screening_readable_transcript: '',

  // evaluated
  evaluation_completed_at: '',
  evaluation_owner_type: '',
  evaluation_owner_id: '',
  evaluation_score: '',
  evaluation_summary: '',

  // post-evaluation action
  action_owner_type: '',
  action_owner_id: '',

  // submitted
  client_submitted_at: '',
  client_submitted_owner_type: '',
  client_submitted_owner_id: '',
  is_sense_influenced_submission: '',
  client_submission_status: '',
  client_submission_id: '',
  indirect_client_submission_id: '',

  // placed
  placed_at: '',
  ats_placed_at: '',
  placed_owner_type: '',
  placed_owner_id: '',
  is_sense_influenced_placement: '',
  placement_start_date: '',
  placement_end_date: '',
  placement_id: '',
  indirect_placement_id: '',

  // archived
  archived_at: '',
  archived_owner_type: '',
  archived_owner_id: '',
  archived_reason: '',
};

export default (
  state: RecruiterHubState = initialState,
  action: RecruiterHubAction,
): RecruiterHubState => {
  switch (action.type) {
    case UPDATE_RECRUITER_HUB_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case RECEIVE_RECRUITER_HUB_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_RECRUITER_HUB_STATE:
      return {...initialState};
  }
  return state;
};
